import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isOrganisationInvoiceLoading = (state: TRootState): boolean =>
  arrayContains(state.organizer.openRequests, [
    Actions.findOrganisationInvoiceRequest.type,
    Actions.findOrganisationInvoicesRequest.type,
    Actions.sendOrganisationInvoicePdfRequest.type,
  ]);
